<template>
  <div class="brand-kit-view">
    <Header />
    <div class="brand-kit-container">
      <div class="brand-kit-header">
        <div class="brand-kit-header-content">
          <div class="title">
            <div>Transit</div>
            <div>{{ $t('brandkit.title') }}</div>
          </div>
          <div class="desc">{{ $t('brandkit.desc') }}</div>
        </div>
        <!-- <img class="bg-img" :src="bgImg" alt="" /> -->
        <picture>
          <source :srcset="bgMobileImg" media="(max-width: 767px)" />
          <img :src="bgImg" alt="" />
        </picture>
      </div>
      <div class="logo-download-content">
        <div class="logo-download">
          <div class="title">{{ $t('brandkit.logoDownload') }}</div>
          <div class="desc">
            <div>{{ $t('brandkit.logoDownloadDesc') }}</div>
            <div>{{ $t('brandkit.logoDownloadDesc_1') }}</div>
          </div>
        </div>
        <div class="download-card-list hidden-scrollbar">
          <div
            class="download-card-item"
            v-for="(item, index) in downloadCardList"
            :key="index"
          >
            <div class="card-img-wrap">
              <img class="card-img" :src="item.icon" alt="" />
            </div>
            <div class="card-version">
              <div class="label">{{ $t('brandkit.colorVersion') }}</div>
              <div class="color-version">
                <a class="type" :href="item.colorVersionPngUrl">PNG</a>
                <a class="type" :href="item.colorVersionSvgUrl">SVG</a>
              </div>
              <div class="label white-label" v-if="index <= 1">
                {{ $t('brandkit.whiteVersion') }}
              </div>
              <div class="color-version white-version" v-if="index <= 1">
                <a class="type" :href="item.whiteVersionPngUrl">PNG</a>
                <a class="type" :href="item.whiteVersionSvgUrl">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="brand-trademark-content">
        <div class="title">{{ $t('brandkit.brandTrademark') }}</div>
        <div class="desc">{{ $t('brandkit.brandTrademarkDesc') }}</div>
        <div class="desc desc-2">{{ $t('brandkit.brandTrademarkDesc_2') }}</div>
        <div class="desc desc-2">{{ $t('brandkit.brandTrademarkDesc_3') }}</div>
        <div class="brand-trademark-version-list">
          <div
            class="brand-trademark-trademark-item hidden-scrollbar"
            v-for="(item, index) in brandTrademarkList"
            :key="index"
          >
            <div class="version-title">{{ item.title }}</div>
            <div class="grid-layout-content trademark-content">
              <div
                class="grid-item trademark-item"
                :class="[
                  `grid-item-${index2}`,
                  { 'trademark-item-blue': index === 1 }
                ]"
                v-for="(item2, index2) in item.children"
                :key="index2"
              >
                <span>{{ item2.label }}</span>
                <img :src="item2.icon" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="spelling-rules-container">
        <div class="spelling-rules-content">
          <div class="spelling-rules-content-left">
            <div class="title">{{ $t('brandkit.spellingRules') }}</div>
            <div class="desc">
              <div>{{ $t('brandkit.spellingRulesDesc') }}</div>
              <div>{{ $t('brandkit.spellingRulesDesc_1') }}</div>
              <div>{{ $t('brandkit.spellingRulesDesc_2') }}</div>
            </div>
          </div>
          <div class="spelling-rules-content-right hidden-scrollbar">
            <div class="top">
              <div
                class="spelling-rules-item"
                :class="[`spelling-rules-item-${index}`]"
                v-for="(item, index) in spellingRuleList.slice(0, 2)"
                :key="index"
              >
                <div class="img-wrap">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="rule-text">
                  <img v-if="item.correct" :src="item.correctIcon" alt="" />
                  <img v-else :src="item.wrongIcon" alt="" />
                  <span>{{ item.rule }}</span>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div
                class="spelling-rules-item"
                :class="[`spelling-rules-item-${index}`]"
                v-for="(item, index) in spellingRuleList.slice(2)"
                :key="index"
              >
                <div class="img-wrap">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="rule-text">
                  <img v-if="item.correct" :src="item.correctIcon" alt="" />
                  <img v-else :src="item.wrongIcon" alt="" />
                  <span>{{ item.rule }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="token-pocket-icon-content">
        <div class="token-pocket-icon-content-left">
          <div class="title">{{ $t('brandkit.TransitIcon') }}</div>
          <div class="desc">
            <div>{{ $t('brandkit.TransitIconDesc') }}</div>
            <div>{{ $t('brandkit.TransitIconDesc_1') }}</div>
          </div>
        </div>
        <div class="token-pocket-icon-content-right hidden-scrollbar">
          <div class="grid-layout-content hidden-scrollbar">
            <div
              class="grid-item"
              :class="[`grid-item-${index}`]"
              v-for="(item, index) in TransitIconList"
              :key="index"
            >
              <span>{{ item.label }}</span>
              <img :src="item.icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="token-pocket-color-content">
        <div class="token-pocket-color-content-left">
          <div class="title">{{ $t('brandkit.TransitColor') }}</div>
          <div class="desc">{{ $t('brandkit.TransitColorDesc') }}</div>
        </div>
        <div class="token-pocket-color-content-right hidden-scrollbar">
          <div class="brand-color brand-blue">
            <div class="brand-row">
              <div class="row-left">{{ $t('brandkit.brandBlue') }}</div>
              <div class="row-right">001</div>
            </div>
            <div class="brand-row">
              <div class="row-left">
                <span>RGB</span>
                <span>{{ $t('brandkit.palette') }}</span>
                <span>#0749F1</span>
                <span>{{ $t('brandkit.primary') }}</span>
              </div>
              <div class="row-right">{{ $t('brandkit.colorSystem') }}</div>
            </div>
          </div>
          <div class="brand-black-white">
            <div class="brand-color brand-black">
              <div class="brand-row">
                <div class="row-left row-left-2 brand-text">{{ $t('brandkit.brandBlack') }}</div>
                <div class="row-right brand-text">002</div>
              </div>
              <div class="brand-row">
                <div class="row-left">
                  <span class="brand-text">RGB</span>
                  <span class="brand-text">{{ $t('brandkit.palette') }}</span>
                  <span class="brand-text">#010109</span>
                  <span class="brand-text">{{ $t('brandkit.secondary') }}</span>
                </div>
                <div class="row-right brand-text">{{ $t('brandkit.colorSystem') }}</div>
              </div>
            </div>
            <div class="brand-color brand-white">
              <div class="brand-row">
                <div class="row-left row-left-2 brand-text">{{ $t('brandkit.OffWhite') }}</div>
                <div class="row-right brand-text">003</div>
              </div>
              <div class="brand-row">
                <div class="row-left">
                  <span class="brand-text">RGB</span>
                  <span class="brand-text">{{ $t('brandkit.palette') }}</span>
                  <span class="brand-text">#F2F2F0</span>
                  <span class="brand-text">{{ $t('brandkit.secondary') }}</span>
                </div>
                <div class="row-right brand-text">{{ $t('brandkit.colorSystem') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Layouts/Header.vue";
import Footer from "../components/Layouts/Footer.vue";

export default {
  name: 'brandkit',
  components: { Header, Footer },
  computed: {
    ...mapGetters(['deviceSize']),
    bgImg() {
      return require(`../assets/brand-kit/bg${this.darkModeImg}.png`)
    },
    bgMobileImg() {
      return require(`../assets/brand-kit/bg-m${this.darkModeImg}.png`)
    },
    downloadCardList() {
      return [
        {
          // icon: require(`../assets/brand-kit/logo-1${this.darkModeImg}.png`),
          icon: require(`../assets/brand-kit/logo-1.png`),
          colorVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version01.png.zip',
          colorVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version01.svg.zip',
          whiteVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version01.png.zip',
          whiteVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version01.svg.zip'
        },
        {
          // icon: require(`../assets/brand-kit/logo-2${this.darkModeImg}.png`),
          icon: require(`../assets/brand-kit/logo-2.png`),
          colorVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version02.png.zip',
          colorVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version02.svg.zip',
          whiteVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version02.png.zip',
          whiteVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version02.svg.zip'
        },
        {
          icon: require(`../assets/brand-kit/logo-3.png`),
          colorVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version03.png.zip',
          colorVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version03.svg.zip',
          // whiteVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version03.png.zip',
          // whiteVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-White-Version03.svg.zip'
        },
        {
          icon: require(`../assets/brand-kit/logo-4.png`),
          colorVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version04.png.zip',
          colorVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version04.svg.zip',
        },
        {
          icon: require(`../assets/brand-kit/logo-5.png`),
          colorVersionPngUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version05.png.zip',
          colorVersionSvgUrl: 'https://hk.tpstatic.net/transit/brand-kit/Transit-Color-Version05.svg.zip',
        }
      ]
    },
    brandTrademarkList() {
      return [
        {
          title: this.$t('brandkit.colorVersion'),
          children: [
            {
              label: this.$t('brandkit.logo'),
              icon: require(`../assets/brand-kit/trademark-1.png`)
            },
            {
              label: this.$t('brandkit.fullVertical'),
              // icon: require(`../assets/brand-kit/trademark-2${this.darkModeImg}.png`)
              icon: require(`../assets/brand-kit/trademark-2.png`)
            },
            {
              label: this.$t('brandkit.fullHorizontal'),
              // icon: require(`../assets/brand-kit/trademark-3${this.darkModeImg}.png`)
              icon: require(`../assets/brand-kit/trademark-3.png`)
            }
          ]
        },
        {
          title: this.$t('brandkit.whiteVersion'),
          children: [
            {
              label: this.$t('brandkit.logo'),
              icon: require(`../assets/brand-kit/trademark-4.png`)
            },
            {
              label: this.$t('brandkit.fullVertical'),
              icon: require(`../assets/brand-kit/trademark-5.png`)
            },
            {
              label: this.$t('brandkit.fullHorizontal'),
              icon: require(`../assets/brand-kit/trademark-6.png`)
            }
          ]
        }
      ]
    },
    spellingRuleList() {
      let mStr = ''
      if (this.deviceSize === 'mobile') {
        mStr = '-m'
      }
      return [
        {
          icon: require(`../assets/brand-kit/token-pocket-1${mStr}${this.darkModeImg}.png`),
          correct: true,
          correctIcon: require(`../assets/brand-kit/correct.png`),
          rule: this.$t('brandkit.representingBrand')
        },
        {
          icon: require(`../assets/brand-kit/token-pocket-2${mStr}${this.darkModeImg}.png`),
          correct: true,
          correctIcon: require(`../assets/brand-kit/correct.png`),
          rule: this.$t('brandkit.applicationBrand')
        },
        {
          icon: require(`../assets/brand-kit/token-pocket-3${mStr}${this.darkModeImg}.png`),
          correct: false,
          wrongIcon: require(`../assets/brand-kit/wrong.png`),
          rule: 'TOKENPOCKET'
        },
        {
          icon: require(`../assets/brand-kit/token-pocket-4${mStr}${this.darkModeImg}.png`),
          correct: false,
          wrongIcon: require(`../assets/brand-kit/wrong.png`),
          rule: 'Tokenpocket'
        },
        {
          icon: require(`../assets/brand-kit/token-pocket-5${mStr}${this.darkModeImg}.png`),
          correct: false,
          wrongIcon: require(`../assets/brand-kit/wrong.png`),
          rule: 'tokenpocket'
        }
      ]
    },
    TransitIconList() {
      return [
        {
          label: this.$t('brandkit.roundedIcon'),
          icon: require(`../assets/brand-kit/token-pocket-icon-1.png`)
        },
        {
          label: this.$t('brandkit.squareIcon'),
          icon: require(`../assets/brand-kit/token-pocket-icon-2.png`)
        },
        {
          label: this.$t('brandkit.socialAvatar'),
          icon: require(`../assets/brand-kit/token-pocket-icon-3.png`)
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.brand-kit-view {
  background: var(--bg-44);
}

.brand-kit-container {
  .title {
    font-size: 52px;
    font-weight: 600;
    color: var(--color-9);
    letter-spacing: 0.05px;
    line-height: normal;
  }
  .desc {
    margin-top: 25px;
    font-size: 20px;
    color: var(--color-12);
    line-height: 34px;
  }
  .desc-2 {
    margin-top: 0;
  }
  .grid-layout-content {
    width: 800px;
    display: grid;
    grid-template-columns: 1fr 1fr; /* 两列等宽 */
    grid-template-rows: auto auto; /* 两行高度自动 */
    gap: 8px;
  }
  .grid-item {
    position: relative;
    width: 396px;
    height: 212px;
    background: var(--bg-37);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      position: absolute;
      left: 12px;
      top: 10px;
      font-size: 10px;
      font-weight: 500;
      color: var(--color-24);
    }
    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }
  .grid-item-2 {
    width: 800px;
    height: 300px;
    grid-column: ~"1 / 3";
  }
  .brand-kit-header {
    position: relative;
    height: 640px;
    font-size: 0;
    .brand-kit-header-content {
      max-width: var(--max-content-width);
      margin: 0 auto;
      height: inherit;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      z-index: 1;
      .title {
        // padding-top: 100px;
        max-width: 590px;
        font-size: 72px;
        font-weight: 700;
      }
      .desc {
        max-width: 590px;
        margin-top: 24px;
        color: var(--color-22);
      }
    }
    picture {
      position: absolute;
      z-index: 0;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      img {
        width: 100%;
        object-fit: cover;
        height: 640px;
      }
    }
  }
  .logo-download-content {
    max-width: var(--max-content-width);
    // max-width: 1300px;
    margin: 106px auto 0;
    .logo-download {
      // max-width: var(--max-content-width);
      // margin: 0 auto;
      .desc {
        margin-top: 25px;
      }
    }
    .download-card-list {
      margin-top: 54px;
      display: flex;
      gap: 0 8px;
      overflow-x: auto;
      .download-card-item {
        flex: 1;
        background: var(--bg-35);
        border-radius: 16px;
        padding: 16px 16px 24px;
        .card-img-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--bg-41);
          border-radius: 16px;
          img {
            // width: 260px;
            // height: 231px;
            width: 234px;
            height: 208px;
          }
        }
        .card-version {
          margin-top: 24px;
          .label {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-23);
          }
          .white-label {
            margin-top: 16px;
          }
          .type {
            width: 110px;
            height: 36px;
            line-height: 36px;
            border: 1px solid var(--border-16);
            border-radius: 61px;
            text-align: center;
            cursor: pointer;
            color: var(--color-23);
            font-size: 14px;
            &:hover {
              border: 1px solid #2980fe;
              background: #2980fe;
              color: #fff;
            }
          }
          .color-version {
            display: flex;
            gap: 0 10px;
            margin-top: 8px;
          }
          .white-version {
            // margin-top: 16px;
          }
        }
      }
    }
  }
  .brand-trademark-content {
    max-width: var(--max-content-width);
    margin: 106px auto 0;
    .brand-trademark-version-list {
      margin-top: 84px;
      display: flex;
      flex-direction: column;
      gap: 72px 0;
      .brand-trademark-trademark-item {
        display: flex;
        overflow-x: auto;
        .version-title {
          width: 400px;
          font-size: 22px;
          font-weight: 600;
          color: var(--color-23);
        }
        .trademark-content {
          flex: 1;
          .trademark-item-2 {
            height: 300px;
          }
          .trademark-item-blue {
            background: #0749F1;
            span {
              color: #fff;
            }
          }
        }
      }
    }
  }
  .spelling-rules-container {
    background: var(--bg-38);
    padding: 115px 0;
    margin-top: 114px;
    .spelling-rules-content {
      max-width: var(--max-content-width);
      margin: 0 auto;
      display: flex;
      .spelling-rules-content-left {
        width: 300px;
        margin-right: 100px;
      }
      .spelling-rules-content-right {
        flex: 1;
        overflow-x: auto;
        .top {
          width: 800px;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0 8px;
        }
        .bottom {
          width: 800px;
          margin-top: 8px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0 8px;
          .spelling-rules-item {
            .img-wrap {
              img {
                width: 261px;
                height: 196px;
              }
            }
          }
        }
        .spelling-rules-item {
          .img-wrap {
            background: var(--bg-42);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              border-radius: 8px;
              width: 396px;
              height: 248px;
            }
          }
          .rule-text {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0 12px;
            height: 36px;
            img {
              width: 20px;
              height: 20px;
            }
            span {
              font-size: 16px;
              color: #71747a;
            }
          }
        }
      }
    }
  }
  .token-pocket-icon-content {
    max-width: var(--max-content-width);
    margin: 125px auto 0;
    display: flex;
    .token-pocket-icon-content-left {
      width: 300px;
      margin-right: 100px;
    }
    .token-pocket-icon-content-right {
      flex: 1;
      overflow-x: auto;
      .grid-item {
        height: 277px;
        background: var(--bg-43);
        span {
          color: var(--color-23);
        }
      }
      .grid-item-2 {
        height: 300px;
      }
    }
  }
  .token-pocket-color-content {
    max-width: var(--max-content-width);
    margin: 227px auto 320px;
    display: flex;
    .token-pocket-color-content-left {
      width: 300px;
      margin-right: 100px;
    }
    .token-pocket-color-content-right {
      flex: 1;
      .brand-color {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 32px;
        font-size: 8px;
        font-weight: 500;
        color: #ffffff;
        .brand-row {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .row-left {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 5px 20px;
          }
        }
      }
      .brand-blue {
        height: 258px;
        background: #0749F1;
        border-radius: 8px;
      }
      .brand-black-white {
        margin-top: 10px;
        display: flex;
        height: 210px;
        .brand-black {
          background: #000000;
          flex: 1;
          border-radius: 8px 0 0 8px;
        }
        .brand-white {
          background: #E7E7E7;
          color: #000;
          flex: 1;
          // height: 210px;
          border-radius: 0 8px 8px 0;
        }
      }
    }
  }
}
@media screen and(max-width: 1300px) {
  .brand-kit-container {
    .desc {
      margin-top: 16px;
    }
    .desc-2 {
      margin-top: 0;
    }
    .grid-layout-content {
      width: 100%;
      gap: 3px;
    }
    .grid-item {
      width: 100%;
      height: auto;
      span {
        left: 12px;
        top: 8px;
      }
      img {
        border-radius: 3px;
      }
    }
    .grid-item-2 {
      width: 100%;
      height: auto;
    }
    .brand-kit-header {
      .brand-kit-header-content {
        padding: 0 20px;
      }
    }
    .logo-download-content {
      padding: 0 20px;
    }
    .brand-trademark-content {
      padding: 0 20px;
      .brand-trademark-version-list {
        .brand-trademark-trademark-item {
          flex-direction: column;
          gap: 16px 0;
        }
      }
    }
    .spelling-rules-container {
      .spelling-rules-content {
        padding: 0 20px;
        flex-direction: column;
        gap: 44px 0;
        .spelling-rules-content-left {
          width: auto;
          margin: 0;
        }
        .spelling-rules-content-right {
          .top {
            width: 100%;
          }
          .bottom {
            width: 100%;
            margin-top: 4px;
            .spelling-rules-item {
              .img-wrap {
                img {
                  width: 100%;
                  height: auto;
                }
              }
            }
          }
          .spelling-rules-item {
            .img-wrap {
              img {
                width: 100%;
                height: auto;
              }
            }
            .rule-text {
              // height: 18px;
              gap: 0 5px;
              img {
                width: 8px;
                height: 8px;
              }
              // span {
              //   font-size: 7px;
              // }
            }
          }
        }
      }
    }
    .token-pocket-icon-content {
      padding: 0 20px;
      flex-direction: column;
      gap: 44px 0;
      .token-pocket-icon-content-left {
        width: auto;
        margin: 0;
      }
      .token-pocket-icon-content-right {
        .grid-item-2 {
          height: auto;
        }
      }
    }
    .token-pocket-color-content {
      padding: 0 20px;
      flex-direction: column;
      gap: 44px 0;
      .token-pocket-color-content-left {
        width: auto;
        margin: 0;
      }
    }
  }
}
@media screen and(max-width: 680px) {
  .brand-kit-container {
    .title {
      font-size: 28px;
    }
    .desc {
      margin-top: 16px;
      font-size: 15px;
      line-height: 24px;
    }
    .desc-2 {
      margin-top: 0;
    }
    .grid-layout-content {
      width: 100%;
      gap: 3px;
    }
    .grid-item {
      // width: 100%;
      // height: 85px;
      width: 100%;
      height: auto;
      span {
        font-size: 4px;
        left: 4px;
        top: 4px;
      }
      img {
        border-radius: 3px;
      }
    }
    .grid-item-2 {
      width: 100%;
      height: auto;
    }
    .brand-kit-header {
      height: 404px;
      .brand-kit-header-content {
        .title {
          max-width: none;
          font-size: 32px;
        }
        .desc {
          max-width: none;
          margin-top: 16px;
        }
      }
      picture {
        img {
          height: 404px;
        }
      }
    }
    .logo-download-content {
      margin: 44px auto 0;
      padding: 0;
      .logo-download {
        padding: 0 20px;
        .desc {
          margin-top: 16px;
        }
      }
      .download-card-list {
        padding: 0 20px;
        margin-top: 48px;
        .download-card-item {
          padding: 10px 10px 14px;
          .card-img-wrap {
            img {
              // width: 167px;
              // height: 148px;
              width: 185px;
              height: 164px;
            }
          }
          .card-version {
            margin-top: 15px;
            .label {
              font-size: 11px;
            }
            .white-label {
              margin-top: 10px;
            }
            .type {
              width: 70px;
              height: 23px;
              line-height: 23px;
              font-size: 9px;
            }
            .color-version {
              margin-top: 5px;
            }
          }
        }
      }
    }
    .brand-trademark-content {
      margin: 88px auto 0;
      .brand-trademark-version-list {
        margin-top: 32px;
        gap: 32px 0;
        .brand-trademark-trademark-item {
          flex-direction: column;
          gap: 16px 0;
          width: 100%;
          .version-title {
            width: auto;
            font-size: 16px;
          }
        }
      }
    }
    .spelling-rules-container {
      padding: 50px 0;
      margin-top: 88px;
      .spelling-rules-content {
        gap: 24px 0;
        .spelling-rules-content-left {
          width: auto;
          margin-right: 0;
        }
        .spelling-rules-content-right {
          .top {
            width: 100%;
          }
          .bottom {
            width: 100%;
            margin-top: 4px;
            .spelling-rules-item {
              .img-wrap {
                img {
                  width: 104px;
                  height: 88px;
                }
              }
            }
          }
          .spelling-rules-item {
            .img-wrap {
              img {
                width: 100%;
                height: auto;
              }
            }
            .rule-text {
              height: 18px;
              gap: 0 5px;
              img {
                width: 8px;
                height: 8px;
              }
              span {
                font-size: 7px;
              }
            }
          }
        }
      }
    }
    .token-pocket-icon-content {
      margin: 44px auto 0;
      gap: 24px 0;
      .token-pocket-icon-content-left {
        margin-right: 0;
        width: auto;
      }
      .token-pocket-icon-content-right {
        .grid-item {
          width: 100%;
          height: auto;
        }
        .grid-item-2 {
          width: 100%;
          height: auto;
        }
      }
    }
    .token-pocket-color-content {
      gap: 24px 0;
      margin: 72px auto 94px;
      .token-pocket-color-content-left {
        width: auto;
        margin: 0;
      }
      .token-pocket-color-content-right {
        .brand-color {
          font-size: 8px;
          padding: 14px;
          .brand-text {
            // display: inline-block;
            // font-size: 8px;
            // transform: scale(0.6);
            // transform-origin: left center;
            white-space: nowrap;
          }
          .brand-row {
            .row-left {
              gap: 5px 5px;
            }
            .row-left-2 {
              grid-template-columns: repeat(1, 1fr);
            }
          }
          .row-right {
            text-align: right;
            white-space: normal;
          }
        }
        .brand-blue {
          height: 104px;
        }
        .brand-black-white {
          margin-top: 4px;
          height: 84px;
        }
      }
    }
  }
}
</style>
